import {
  addDoc,
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import React, { useEffect, useState } from "react";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import toast from "react-simple-toasts";

import styled from "styled-components";
import Navbar from "../../Components/Navbar";
import { ButtonInput, Container } from "../../Components/reusable_components";
import { ToastTimer } from "../../data";
import { auth, fireStoredb, storage } from "../../firebase_config";

const PostBody = styled.div`
  width: 80%;
  height: calc(100vh - 150px);
  margin: auto;
  overflow: hidden;
`;

const SideBar = styled.div`
  width: 25%;
  height: 100vh;
  /* background-color: red; */
  @media screen and (max-width: 770px) {
    display: none;
  }
`;
const PostCollection = styled.div`
  width: 50%;
  overflow: scroll;
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  @media screen and (max-width: 770px) {
    width: 100%;
  }
  /* background-color: white; */
`;
const ProfileSection = styled.div`
  width: 25%;
  min-height: 300px;
  margin: 20px 0;
  border: 1px solid #693b93;
  @media screen and (max-width: 770px) {
    display: none;
  }
`;
const PostCollectionWrapper = styled.div`
  width: 100%;
  height: auto;
`;
const Cards = styled.div`
  width: 90%;
  height: 480px;
  padding: 20px;

  border: 1px solid #693b93;
  margin: 20px auto;
`;
const CardHeader = styled.div`
  width: 100%;
  height: auto;
  /* background-color: green; */
`;
const AvatarWrapper = styled.div`
  width: 30%;
  min-width: 100px;
  height: auto;
  margin: 5px;
  /* background-color: #30114d; */
`;
const UserContent = styled.div`
  width: 70%;
  height: auto;
  /* background-color: green; */
`;
const AvatarImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 3px;
  object-fit: contain;

  padding: 5px;
`;
const UserNameWrapper = styled.div`
  width: 80%;
  height: auto;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
  text-transform: capitalize;
  white-space: nowrap;
`;
const CardBody = styled.div`
  width: 100%;
  height: 60%;
  margin: 10px auto;
  background-color: #693b93;
`;
const PostImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const CardFooter = styled.div`
  width: 100%;
  height: auto;
`;
const Caption = styled.div`
  width: 100%;
  height: 52px;
  color: #fff;
  font-size: 13px;
  overflow: hidden;
`;
const Posts = () => {
  const [userProfileData, setuserProfileData] = useState({});
  const [userPostData, setuserPostData] = useState([]);
  useEffect(() => {
    const gettingProfileData = async () => {
      try {
        const docRef = doc(fireStoredb, "user", auth.currentUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setuserProfileData(docSnap.data());
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      } catch (err) {
        toast(err.message, ToastTimer);
      }
    };
    const gettingPostsData = async () => {
      try {
        const q = query(
          collection(fireStoredb, "posts"),
          where("visible", "==", true),
          orderBy("createdAt", "desc")
        );

        let productwithUser = [];
        onSnapshot(q, (querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            let newItem = { id: doc.id, ...doc.data() };

            let userData = await getDoc(newItem.userRef);

            newItem = { ...userData.data(), ...newItem };

            productwithUser.push(newItem);
            setuserPostData(productwithUser);
          });
        });
      } catch (err) {
        console.log(err);
        toast(err.message, ToastTimer);
      }
    };
    auth.currentUser?.uid && gettingPostsData();
    auth.currentUser?.uid && gettingProfileData();
  }, []);

  return (
    <>
      <Navbar />
      <PostBody className="d-flex">
        <SideBar></SideBar>
        <PostCollection>
          <PostCollectionWrapper>
            {userPostData.map((d, index) => (
              <PostCollectionCard data={d} key={index} />
            ))}
          </PostCollectionWrapper>
        </PostCollection>
        <ProfileSection>
          <ProfileSectionContent data={userProfileData} />
        </ProfileSection>
      </PostBody>
    </>
  );
};
const PostCollectionCard = ({ data }) => {
  const handleLike_dislike = async (id) => {
    try {
      const docRef = doc(fireStoredb, "posts", id);

      if (data.like?.includes(auth.currentUser?.uid)) {
        await updateDoc(docRef, {
          like: arrayRemove(auth.currentUser.uid),
        });
      } else {
        await updateDoc(docRef, {
          like: arrayUnion(auth.currentUser.uid),
        });
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <Cards>
      <CardHeader className="d-flex justify-between align-center">
        <AvatarWrapper className="d-flex justify-center align-center">
          <AvatarImage src={data?.avatar} />
        </AvatarWrapper>
        <UserContent>
          <UserNameWrapper className="d-flex justify-center align-center">
            {data?.username}
          </UserNameWrapper>
        </UserContent>
      </CardHeader>
      <CardBody>
        <PostImage src={data?.imagePath} />
      </CardBody>
      <CardFooter>
        <span
          className="d-flex align-center"
          onClick={() => handleLike_dislike(data.id)}
        >
          {data.like?.includes(auth.currentUser?.uid) ? (
            <AiFillHeart
              size={24}
              style={{ color: "#693b93", cursor: "pointer" }}
            />
          ) : (
            <AiOutlineHeart
              size={24}
              style={{ color: "#693b93", cursor: "pointer" }}
            />
          )}
          <strong style={{ color: "#fff" }}>{data.like.length}</strong>
        </span>
        <Caption>
          <p>
            <strong style={{ fontSize: "16px" }}>{data?.username} </strong>
            {data?.caption}
          </p>
        </Caption>
      </CardFooter>
    </Cards>
  );
};
const ProfileSectionBox = styled.div`
  width: 100%;
  height: 100%;
`;
const ProfileSectionContent = ({ data }) => {
  // uploading posts

  const [file, setfile] = useState(null);
  const [caption, setCaption] = useState("");
  const handlePostUpload = () => {
    if (file === null) {
      return toast("File is required", ToastTimer);
    }
    if (caption === "") {
      return toast("Caption is required", ToastTimer);
    }
    if (file.size > 566400)
      return toast("File size should be less than 500kb", ToastTimer);
    const exte = ["png", "jpeg", "jpg"];
    if (!exte.includes(file?.name.substring(file.name.lastIndexOf(".") + 1))) {
      return toast("File must be png,jpeg,jpg", ToastTimer);
    }

    const storageRef = ref(
      storage,
      `${auth.currentUser.uid}/` + Date.now() + file.name
    );
    const uploadTask = uploadBytesResumable(storageRef, file, "image/jpeg");

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
      },
      (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            toast(
              "User doesn't have permission to access the object",
              ToastTimer
            );
            // User doesn't have permission to access the object
            break;
          case "storage/canceled":
            toast("User canceled the upload", ToastTimer);
            // User canceled the upload
            break;
          case "storage/unknown":
            toast("Unknown error occurred", ToastTimer);
            // Unknown error occurred, inspect error.serverResponse
            break;
          default:
            toast("Something went wrong", ToastTimer);
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          const docRef = doc(fireStoredb, "user", auth.currentUser.uid);
          addDoc(collection(fireStoredb, "posts"), {
            imagePath: downloadURL,
            caption: caption,
            createdAt: Timestamp.now(),
            userRef: docRef,
            uerId: auth.currentUser.uid,
            like: [auth.currentUser.uid],
            visible: false,
          })
            .then((res) => {
              setCaption("");
              setfile(null);
              toast(
                "Post will be visible after owner varification...",
                ToastTimer
              );
            })
            .catch((err) => {
              console.log(err);
            });
        });
      }
    );
  };

  return (
    <ProfileSectionBox>
      <Container className="d-flex">
        <AvatarWrapper className="d-flex justify-center align-center">
          <AvatarImage src={data?.avatar} />
        </AvatarWrapper>
        <UserContent>
          <UserNameWrapper className="d-flex justify-center align-center">
            {data?.username}
          </UserNameWrapper>
          <ButtonInput value="Edit" />
        </UserContent>
      </Container>
      <Container className="d-flex justify-around" style={{ color: "#fff" }}>
        <span>
          Followers<strong>&nbsp; 2 M</strong>
        </span>
        <span>
          Following<strong>&nbsp; 10</strong>
        </span>
      </Container>
      <Container className="d-flex justify-center align-center">
        <input
          type="file"
          id="uploadFile"
          onChange={(e) => setfile(e.target.files[0])}
        />
        <ButtonInput value="upload posts" onClick={handlePostUpload} />
      </Container>
      <Container className="d-flex justify-center align-center">
        <textarea
          style={{ padding: "10px" }}
          name=""
          id=""
          cols="30"
          rows="10"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          placeholder="Write Your Thoughts Here..."
        ></textarea>
      </Container>
    </ProfileSectionBox>
  );
};
export default Posts;
